import React from "react";
import { Box, Grid, TextField, Typography } from "@mui/material";

const BasicDetails = ({ form, setField, isMobile, showErrors }) => {
  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
        Basic Details
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} width={isMobile ? "100%" : "48%"}>
          <TextField
            fullWidth
            label="Name"
            value={form.name}
            onChange={(e) => setField("name", e.target.value)}
            error={showErrors && !form.name}
            helperText={showErrors && !form.name ? "Name is required" : ""}
          />
        </Grid>

        <Grid item xs={12} sm={6} width={isMobile ? "100%" : "48%"}>
          <TextField
            fullWidth
            label="Email"
            type="email"
            value={form.email}
            onChange={(e) => setField("email", e.target.value)}
            error={
              showErrors && (!form.email || !form.email.includes("@")) // must contain "@"
            }
            helperText={
              showErrors && !form.email
                ? "Email is required"
                : showErrors && !form.email.includes("@")
                  ? "Email must contain '@'"
                  : ""
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} width={isMobile ? "100%" : "48%"}>
          <TextField
            fullWidth
            label="Phone"
            type="tel"
            value={form.phone}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value)) {
                // allow only digits
                setField("phone", value);
              }
            }}
            error={showErrors && !form.phone}
            helperText={showErrors && !form.phone ? "Phone is required" : ""}
          />
        </Grid>

        <Grid item xs={12} sm={6} width={isMobile ? "100%" : "48%"}>
          <TextField
            fullWidth
            label="Password"
            type="password"
            value={form.password}
            onChange={(e) => setField("password", e.target.value)}
            error={
              showErrors &&
              (!form.password ||
                !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{7,}$/.test(
                  form.password,
                ))
            }
            helperText={
              showErrors && !form.password
                ? "Password is required"
                : showErrors &&
                    !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{7,}$/.test(
                      form.password,
                    )
                  ? "Password must be at least 7 characters, include uppercase, lowercase, and a special character."
                  : ""
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
};
export default BasicDetails;
